import React, { useRef } from 'react';

// style imports
import "./Input.css";

const TextInput = ({ label, id, onChange, initialValue, maxLength, readOnly, notes }) => {
  // Create a ref to manage the input focus
  const inputRef = useRef(null);

  // Focus the input field when label is clicked
  const handleEditClick = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  // Handle onChange and detect when input has a value
  const handleOnChange = (e) => {
    let value = e.target.value;

    // Remove any non-numeric characters except '.'
    value = value.replace(/[^\d.]/g, "");

    // Handle multiple decimals or improper inputs
    const parts = value.split(".");
    if (parts.length > 2) {
      value = parts[0] + "." + parts[1]; // Allow only one decimal point
    }

    // Limit to 2 decimal places
    if (parts[1]?.length > 2) {
      value = `${parts[0]}.${parts[1].slice(0, 2)}`;
    }
    
    // Dynamically insert a decimal if the number exceeds 100
    if (parseFloat(value) > 100) {
      // Shift the decimal to create a valid percentage format
      const adjustedValue = (parseFloat(value) / 10).toFixed(3);
      value = adjustedValue;
    }
    if (onChange) {
      onChange(value)
    }
  };

  return (
    <div className="form-input" onClick={handleEditClick}>
      <input type="text" id={id} value={initialValue}
        placeholder={label} onChange={handleOnChange} ref={inputRef} maxLength={maxLength}
        readOnly={readOnly} />
      <label htmlFor={label}>{label} <span>{notes}</span></label>
    </div>
  );
};

export default TextInput;
